var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{attrs:{"type":"checkbox","id":_vm.id,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":function($event){return _vm.onValueChange(_vm.data)}}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.labelText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }